// extracted by mini-css-extract-plugin
module.exports = {"container":"StripDataMoveable_container__neCMm","marquee":"StripDataMoveable_marquee__rtDLM"};